import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/vehicle'

const secondBaseEndpoint = '/canbus-formulas'

export const getByVehicleId = async (vehicleId, serverRegion) => {
    const response = await apiClient({
        method: 'GET',
        url: `${baseEndpoint}/${vehicleId}${secondBaseEndpoint}`,
        headers: {
            'X-Region': serverRegion,
        },
    })

    return response?.data
}


export const getModels = async (queryParam, serverRegion) => {
    const params = {
        brand: queryParam?.brand || undefined,
    }

    const response = await apiClient({
        method: 'GET',
        url: `${secondBaseEndpoint}/models`,
        params: params,
        headers: {
            'X-Region': serverRegion,
        },
    })

    return response?.data
}

export const getBrands = async (serverRegion) => {
    const response = await apiClient({
        method: 'GET',
        url: `${secondBaseEndpoint}/brands`,
        headers: {
            'X-Region': serverRegion,
        },
    })

    return response?.data
}
